import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { useAuthModal } from '../contexts/AuthModalContext';
import { setPostAuthRedirect } from '../utils/postAuthRedirect';

/**
 * Hook to handle navigation to protected routes
 * - If authenticated: Navigate normally
 * - If not authenticated: Open login modal and store intended route
 */
export const useProtectedNavigation = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const { openLoginModal } = useAuthModal();

  const navigateToProtectedRoute = useCallback((path: string, event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault();
    }

    if (isAuthenticated) {
      // User is authenticated, navigate normally
      navigate(path);
    } else {
      // User is not authenticated, open modal and store intended route
      setPostAuthRedirect(path);
      openLoginModal();
    }
  }, [isAuthenticated, navigate, openLoginModal]);

  return { navigateToProtectedRoute };
};
